import { render, staticRenderFns } from "./TrackingCode.vue?vue&type=template&id=1a36348e&scoped=true"
import script from "./TrackingCode.vue?vue&type=script&lang=js"
export * from "./TrackingCode.vue?vue&type=script&lang=js"
import style0 from "./TrackingCode.vue?vue&type=style&index=0&id=1a36348e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36348e",
  null
  
)

export default component.exports